import type { TranslationKey } from "~/helpers/common-helpers";

export const usePageTitle = (
  args: { position?: number } & ({ translationKey: MaybeRefOrGetter<TranslationKey> } | { title: MaybeRefOrGetter<Nullable<string>> })
) => {
  const store = usePageTitleStore();

  const id = useId();

  onMounted(() => {
    store.addSegment({ id, ...args, position: args.position ?? 0 });
  });

  onUnmounted(() => {
    store.removeSegment(id);
  });
};
